/* global axios */
import { encrypt } from '../../v3/helpers/encrypt';
import ApiClient from './ApiClient';
import { format } from 'date-fns';
class CrmApi extends ApiClient {
  constructor() {
    super('crm_dashboard', { accountScoped: true });
  }

  sendData({
    accountId,
    token,
    filterResponseTime = {},
    filterNewLeads = {},
    filterContactsPerChannel = {},
    filterScheduleOccupations = {},
  } = {}) {
    const time = format(new Date(), 'HH:mm').toString();
    const encrypted_token = encrypt(token, time);
    return axios.post(`${this.url}/send_data`, {
      account_id: accountId,
      token: encrypted_token,
      time: time,
      filter_response_time: filterResponseTime,
      filter_new_leads: filterNewLeads,
      filter_contacts_per_channel: filterContactsPerChannel,
      filter_schedule_occupations: filterScheduleOccupations,
    });
  }
}

export default new CrmApi();
